import { Tooltip } from "@chakra-ui/react";

export const CustomTooltip = ({ label, labelOnDisabled, childrenProps, children }) => (
    <Tooltip
        label={label(childrenProps)}
        shouldWrapChildren
        // isDisabled={isDisabled}
    >
        {children(childrenProps)}
    </Tooltip>
)